import { RestService } from './helper/rest-service';
import { Observable } from 'rxjs/Rx';
import { Inject, Injectable } from '@angular/core';
import { BaseEndpoint } from './../app.constants';
import { Adal5Service } from 'adal-angular5';
import { Http, Response, Headers } from '@angular/http';

@Injectable()
export class BaseService {
  headers: Headers;

  constructor(private restService: RestService, @Inject(BaseEndpoint) private baseApiEndpoint , private adalService: Adal5Service) {

    this.headers = new Headers();
  
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    
  }

  getMapDescriptions(token): Promise<any> {
    this.headers.delete('Authorization');
    this.headers.append('Authorization', 'Bearer ' + this.adalService.userInfo.token);
    return this.restService.get(this.baseApiEndpoint + '/api/processMaps', this.headers);
  }
  getPointsOfInterest(map: number): Promise<any> {
    this.headers.delete('Authorization');
    this.headers.append('Authorization', 'Bearer ' + this.adalService.userInfo.token);
    return this.restService.get(this.baseApiEndpoint + '/api/PointsOfInterest/' + map, this.headers);
  }
  getCategories(): Promise<any>{
    this.headers.delete('Authorization');
    this.headers.append('Authorization', 'Bearer ' + this.adalService.userInfo.token);
    return this.restService.get(this.baseApiEndpoint + '/api/categories/', this.headers);
  }
  customMap(): Promise<any> {

    return this.restService.get('/assets/additives.json', '');
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/_services/base.service.ts